"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invertObject = exports.extToExponential = exports.getRealNumValueStr = exports.choose_fmt = exports.splitFormat = exports.fmtIsDate = exports.isGeneral = exports._strrev = exports.pad0r = exports.pad0r2 = exports.pad0r1 = exports.rpad_ = exports.pad_ = exports.pad0 = exports.isNumeric = exports.fill = void 0;
/**
 * 自动填充字符串
 * @param str 要重复的字符
 * @param len 要重复生成的长度
 */
function fill(c, l) {
    var o = '';
    while (o.length < l)
        o += c;
    return o;
}
exports.fill = fill;
/**
 * 判断n是否是数字类型
 * @param n
 */
function isNumeric(n) {
    var t = typeof n;
    if (t === 'string' && n.toLowerCase().indexOf('0x') === 0) {
        // 不处理16进制
        return false;
    }
    return t == 'number'
        ? !isNaN(n) && isFinite(n)
        : t == 'string'
            ? !n.length
                ? false
                : n.length == 1
                    ? /\d/.test(n)
                    : /^\s*[+-]?\s*(?:(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?)|(?:0x[a-f\d]+))\s*$/i.test(n)
            : t == 'object'
                ? !!n && typeof n.valueOf() === 'number' && !(n instanceof Date)
                : false;
}
exports.isNumeric = isNumeric;
/**
 * 当v的长度不够d的时候 用0补充到长度d
 * @param v
 * @param d
 */
function pad0(v, d) {
    var t = "" + v;
    return t.length >= d ? t : fill('0', d - t.length) + t;
}
exports.pad0 = pad0;
function pad_(v, d) {
    var t = "" + v;
    return t.length >= d ? t : fill(' ', d - t.length) + t;
}
exports.pad_ = pad_;
function rpad_(v, d) {
    var t = "" + v;
    t = getRealNumValueStr(t);
    return t.length >= d ? t : t + fill(' ', d - t.length);
}
exports.rpad_ = rpad_;
function pad0r1(v, d) {
    var t = "" + Math.round(v);
    t = getRealNumValueStr(t);
    return t.length >= d ? t : fill('0', d - t.length) + t;
}
exports.pad0r1 = pad0r1;
function pad0r2(v, d) {
    var t = "" + v;
    t = getRealNumValueStr(t);
    return t.length >= d ? t : fill('0', d - t.length) + t;
}
exports.pad0r2 = pad0r2;
var p2_32 = Math.pow(2, 32);
function pad0r(v, d) {
    if (v > p2_32 || v < -p2_32)
        return pad0r1(v, d);
    var i = Math.round(v);
    return pad0r2(i, d);
}
exports.pad0r = pad0r;
function _strrev(x) {
    var o = '';
    var i = x.length - 1;
    while (i >= 0) {
        o += x.charAt(i);
        i -= 1;
    }
    return o;
}
exports._strrev = _strrev;
/**
 * 利用字符码判断输入格式串是否是 General
 * @param foramt 输入 format 字符串
 * @param startIndex 判断起始位置
 */
function isGeneral(format, startIndex) {
    startIndex = startIndex || 0;
    return (format.length >= 7 + startIndex &&
        (format.charCodeAt(startIndex) | 32) === 103 &&
        (format.charCodeAt(startIndex + 1) | 32) === 101 &&
        (format.charCodeAt(startIndex + 2) | 32) === 110 &&
        (format.charCodeAt(startIndex + 3) | 32) === 101 &&
        (format.charCodeAt(startIndex + 4) | 32) === 114 &&
        (format.charCodeAt(startIndex + 5) | 32) === 97 &&
        (format.charCodeAt(startIndex + 6) | 32) === 108);
}
exports.isGeneral = isGeneral;
/**
 * 判断是不是日期, 根据是否命中特殊字符进行判断
 * @param foramt 输入 format 格式串
 */
function fmtIsDate(format) {
    var currentChar;
    var index = 0;
    while (index < format.length) {
        switch ((currentChar = format.charAt(index))) {
            case 'G': {
                if (isGeneral(format, index)) {
                    index += 6;
                }
                index += 1;
                break;
            }
            case '"': {
                var isEndQuotation = false;
                while (index + 1 < format.length) {
                    index += 1;
                    if (format.charCodeAt(index) === 34) {
                        isEndQuotation = true;
                        break;
                    }
                }
                // 没有 " 作为结束说明格式串异常, 直接返回
                if (!isEndQuotation) {
                    return false;
                }
                index += 1;
                break;
            }
            case '\\': {
                index += 2;
                break;
            }
            case '_': {
                index += 2;
                break;
            }
            case 'B':
            case 'b': {
                if (format.charAt(index + 1) === '1' || format.charAt(index + 1) === '2') {
                    return true;
                }
                index += 1;
                break;
            }
            // 以下均为时间、 日期关键词
            case 'M':
            case 'D':
            case 'Y':
            case 'H':
            case 'S':
            case 'E':
            case 'm':
            case 'd':
            case 'y':
            case 'h':
            case 's':
            case 'e':
            case 'g': {
                return true;
            }
            case 'A':
            case 'a': {
                // 判断接下来三个字符
                var nextString = format.substr(index, 3);
                // 上午下午
                if (nextString.toUpperCase() === 'A/P') {
                    return true;
                }
                // 周几
                if (nextString.toUpperCase() === 'AAA') {
                    return true;
                }
                // 判断接下来四个字符
                nextString = format.substr(index, 4);
                // 星期几
                if (nextString.toUpperCase() === 'AAAA') {
                    return true;
                }
                // 判断接下来五个字符
                nextString = format.substr(index, 5);
                // 上午下午
                if (nextString.toUpperCase() === 'AM/PM') {
                    return true;
                }
                index += 1;
                break;
            }
            case '上': {
                // 上午下午
                if (format.substr(index, 5).toUpperCase() === '上午/下午') {
                    return true;
                }
                index += 1;
                break;
            }
            case '[': {
                var tempString = currentChar;
                while (format.charAt(index) !== ']') {
                    index += 1;
                    if (index >= format.length) {
                        break;
                    }
                    tempString += format.charAt(index);
                }
                // [] 内为时间关键词
                if (tempString.match(/\[[HhMmSs]*\]/)) {
                    return true;
                }
                break;
            }
            case '.':
            case '0':
            case '#': {
                while (index < format.length) {
                    index += 1;
                    currentChar = format.charAt(index);
                    if (('0#?.,E+-%'.indexOf(currentChar) > -1)
                        || (currentChar === '\\'
                            && format.charAt(index + 1) == '-'
                            && '0#'.indexOf(format.charAt(index + 2)) > -1)) {
                        continue;
                    }
                    else {
                        break;
                    }
                }
                break;
            }
            case '?': {
                index += 1;
                while (format.charAt(index) === currentChar) {
                    index += 1;
                }
                break;
            }
            case '*': {
                index += 1;
                if ((format.charAt(index) == ' ') || (format.charAt(index) == '*')) {
                    index += 1;
                }
                break;
            }
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9': {
                while (index < format.length) {
                    index += 1;
                    currentChar = format.charAt(index);
                    if ('0123456789'.indexOf(currentChar) === -1) {
                        break;
                    }
                }
                break;
            }
            default: {
                index += 1;
                break;
            }
        }
    }
    return false;
}
exports.fmtIsDate = fmtIsDate;
// 根据分号分割格式串
function splitFormat(fmt) {
    var out = [];
    var inStr = false;
    var i;
    var j;
    for (i = 0, j = 0; i < fmt.length; i += 1) {
        switch ( /* cc= */fmt.charCodeAt(i)) {
            case 34 /* '"' */:
                inStr = !inStr;
                break;
            case 95: /* '_' */
            case 92: /* '\\' */
            case 42 /*   '*'   */:
                if (!inStr) {
                    i += 1;
                }
                break;
            case 59 /* ';' */:
                if (!inStr) {
                    out[out.length] = fmt.substr(j, i - j);
                    j = i + 1;
                }
                break;
        }
    }
    out[out.length] = fmt.substr(j);
    if (inStr === true)
        throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
exports.splitFormat = splitFormat;
/** 条件格式 */
var cfregex = /\[[=<>]/;
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
// 条件判断
function chkcond(v, rr) {
    if (rr == null)
        return false;
    var thresh = parseFloat(rr[2]);
    switch (rr[1]) {
        case '=':
            if (v == thresh)
                return true;
            break;
        case '>':
            if (v > thresh)
                return true;
            break;
        case '<':
            if (v < thresh)
                return true;
            break;
        case '<>':
            if (v != thresh)
                return true;
            break;
        case '>=':
            if (v >= thresh)
                return true;
            break;
        case '<=':
            if (v <= thresh)
                return true;
            break;
    }
    return false;
}
// 根据内容选择对应的格式
function choose_fmt(f, v) {
    var fmt = ['General'];
    try {
        fmt = splitFormat(f);
    }
    catch (error) {
        // 分割格式串的时候可能会遇到各种异常
        fmt = ['General'];
    }
    var l = fmt.length;
    var lat = fmt[l - 1].indexOf('@');
    if (l < 4 && lat > -1)
        --l;
    // if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");//如果大于4个  直接不处理就好了
    // if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
    switch (fmt.length) {
        case 1:
            fmt = lat > -1 ? [fmt[0], fmt[0], fmt[0], fmt[0]] : [fmt[0], fmt[0], fmt[0], '@'];
            break;
        case 2:
            fmt = lat > -1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], '@'];
            break;
        case 3:
            fmt = lat > -1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], '@'];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (isNaN(v)) {
        // 非数字直接返回最后一个
        ff = fmt[3];
        return { length: l, fmt: ff };
    }
    if (fmt[0].indexOf('[') === -1 && fmt[1].indexOf('[') === -1)
        return { length: l, fmt: ff };
    if (fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
        var m1 = fmt[0].match(cfregex2);
        var m2 = fmt[1].match(cfregex2);
        return chkcond(v, m1)
            ? { length: l, fmt: fmt[0] }
            : chkcond(v, m2)
                ? { length: l, fmt: fmt[1] }
                : { length: l, fmt: fmt[m1 != null && m2 != null ? 2 : 1] };
    }
    return { length: l, fmt: ff };
}
exports.choose_fmt = choose_fmt;
/**
 * 获取科学计数法对应的普通数字串
 * @param val
 */
function getRealNumValueStr(val) {
    if (typeof val !== 'string') {
        val = val.toString();
    }
    // let frontStr = val.match(/(.*)(?=[eE])/g)[1];//e符号前面的数值
    // let floatStr = val.match(/[eE][+-](\d*)/g)[1];//e符号后面的数值
    var regResult = val.match(/((-?\d+\.\d+)|(-?\d+))[eE]([+-]?\d+)/);
    if (!regResult) {
        // 不需要处理 直接返回
        return val;
    }
    var numStr = regResult[1];
    var power = regResult[4];
    var out = val;
    if (power === undefined) {
        // 如果没有指数部分 直接返回吧  算不了了
        return out;
    }
    if (regResult) {
        var dotIndex = val.indexOf('.');
        var powerNum = parseFloat(power);
        if (powerNum >= 0) {
            // 指数部分是正数或者0
            if (dotIndex !== -1) {
                out = val.substr(0, dotIndex); // 初始值为小数点和小数点前面的数值
                var nextIndex = dotIndex; // 这里正常应该都是2  因为科学计数法的小数点就是在第二位的位置
                for (var i = 0; i < powerNum; i += 1) {
                    nextIndex = dotIndex + i + 1;
                    if (nextIndex < numStr.length) {
                        out += numStr.charAt(nextIndex);
                    }
                    else {
                        out += '0';
                    }
                }
                if (nextIndex < numStr.length - 1) {
                    // 如果转换后还有小数位没有用完 就加到后面
                    out += '.';
                    out += numStr.substr(nextIndex + 1);
                }
            }
            else {
                var eIndex = val.toLowerCase().indexOf('e');
                out = val.substr(0, eIndex);
                out = out + fill('0', Math.abs(powerNum));
            }
        }
        else {
            // 指数部分为负数
            out = numStr.replace('.', ''); // 初始值为去掉小数点后的所有数值
            // 正负矫正
            var sign = out.startsWith('-') ? '-' : '';
            if (sign) {
                out = out.replace(sign, '');
            }
            out = sign + "0." + fill('0', Math.abs(powerNum) - 1) + out;
        }
    }
    return out;
}
exports.getRealNumValueStr = getRealNumValueStr;
/**
 * 获取数字对应的科学记数法表示
 * 原生的 toExponential 存在几个问题
 * 1. 有效位数的上限因浏览器而不同，一般是 0-20
 * 2. 最高位数为 100，超过后会显示原始值，转不了科学记数
 * 3. 达到或超过 17 位数会显示错误，例如 1.23 的 toExponential(17) 会显示一堆乱的数字
 * 因此慎用 toExponential, 添加这个函数解决以上的问题
 */
function extToExponential(num, len) {
    if (typeof num !== 'number')
        return String(num);
    num = num.toString();
    if (num === 'Infinity' || num === '-Infinity')
        return num;
    if (num.includes('e') || num.includes('E'))
        num = getRealNumValueStr(num);
    if (len === undefined)
        len = num.replace(/[^\d]/g, '').length - 1;
    if (!num.includes('.'))
        num = num + ".0";
    var isMinus = num[0] === '-';
    num = num.replace(/^-?([0-9.]+)$/, '$1');
    var oriIndex = num.indexOf('.');
    var aftIndex = num
        .replace(/[.]/g, '')
        .replace(/^(0*)([^0])([0-9]*)$/, '$1$2.$3')
        .indexOf('.');
    var powerLen = oriIndex - aftIndex;
    var power = powerLen === 0 ? 'e+0' : "e" + (powerLen > 0 ? "+" + powerLen : "" + powerLen);
    num = num.replace(/[.]/g, '').replace(/^(0*)([^0])([0-9]*)$/, '$2.$30');
    if (/^0+$/.test(num)) {
        return "0." + new Array(len).fill('0').join('') + "e+0";
    }
    var parts = num.match(/^([1-9])\.([0-9]+)$/);
    var intPart = (parts === null || parts === void 0 ? void 0 : parts[1]) || '';
    var decPart = (parts === null || parts === void 0 ? void 0 : parts[2]) || '';
    if (decPart.length > len) {
        var last = decPart.slice(len, len + 1);
        decPart = decPart.slice(0, len);
        if (parseInt(last) > 4)
            decPart = decPart.slice(0, len - 1) + (parseInt(decPart.slice(-1)) + 1).toString();
    }
    else {
        decPart = decPart + new Array(len - decPart.length).fill('0').join('');
    }
    decPart = decPart === '' ? '' : "." + decPart;
    return (isMinus ? '-' : '') + intPart + decPart + power;
}
exports.extToExponential = extToExponential;
exports.invertObject = function (obj) {
    return Object.keys(obj).reduce(function (objNew, key) {
        objNew[obj[key]] = key;
        return objNew;
    }, {});
};
//# sourceMappingURL=Common.js.map